import React, { useState, useEffect, useMemo } from 'react'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography, Stack, LinearProgress, Pagination, TextField } from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import { borderColor, borderRadius, styled } from '@mui/system'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import 'dayjs/locale/ko'
import dayjs from 'dayjs'
import { Tabs } from '@mui/base/Tabs'
import { TabsList as BaseTabsList } from '@mui/base/TabsList'
import { TabPanel as BaseTabPanel } from '@mui/base/TabPanel'
import { buttonClasses } from '@mui/base/Button'
import { Tab as BaseTab, tabClasses } from '@mui/base/Tab'
import Paper from '@mui/material/Paper'
import Api from '../../../Api/Api'
import { TreeSelect } from 'antd'
import Loader from '../../../Components/Loading'
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table'
// import ExportToExcel from '../../../Components/ExportToExcel'
import excel_img from '../../../asset/excel_img.png'
import * as XLSX from 'xlsx'
import secureLocalStorage from 'react-secure-storage'

const Title = (props) => {
  // console.log('render')
  return <Typography>{props.title}</Typography>
}

const MyPagination = styled(Pagination)({
  '& .Mui-selected': {
    border: '1px solid',
    borderImageSource:
      'linear-gradient(166.93deg, #AFAFAF 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 67.95%)',
    backgroundColor:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 5.98%, rgba(0, 0, 0, 0) 66.28%)',
    color: '#ffffff',
  },
  '& .MuiPaginationItem-root': {
    color: '#ffffff',
  },
  //There has a lot of Global classes. you have to use it according to your requirement
  //Some classes are MuiPaginationItem-root, MuiPaginationItem-page and Mui-selected
})

const blue = {
  50: '#F0F7FF',
  100: '#C2E0FF',
  200: '#80BFFF',
  300: '#66B2FF',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
  700: '#0059B2',
  800: '#004C99',
  900: '#003A75',
}

const Tab = styled(BaseTab)`
  font-family: 'IBM Plex Sans', sans-serif;
  color: white;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: transparent;
  width: 100%;
  line-height: 1.5;
  padding: 8px 12px;
  margin: 6px;
  border: none;
  border-radius: 50px;
  display: flex;
  justify-content: center;

  &.base-Tab-root {
    color: #00000099;
  }
  &:hover {
    background-color: ${blue[400]};
  }

  &:focus {
    color: #fff;
  }

  &.${tabClasses.selected} {
    background: linear-gradient(89.58deg, #628eff 10%, #8740cd 57.32%, #580475 99.08%);
    background-color: #fff;
    color: #fff;
  }

  &.${buttonClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const TabPanel = styled(BaseTabPanel)`
  width: 100%;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
`

const TabsList = styled(BaseTabsList)(
  ({ theme }) => `
  min-width: 400px;
  background-color: #fff;
  border-radius: 50px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  place-content: space-between center;
  box-shadow: 0 4px 6px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.4)' : 'rgba(0,0,0, 0.2)'};
  `
)

const styles1 = {
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography2: {
    color: '#ffffff',
    fontFamily: 'Montserrat',
    fontSize: '10px',
    fontWeight: 600,
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Box1: {
    display: 'flex',
    justifyContent: 'center',
    alignItem: 'center',
    width: '100%',
    height: 122,
    background: '#171821',
    boxShadow: '3px 3px 4px 0px #00000099',
  },
  Box2: {
    minWidth: 120,
    marginTop: 1,
  },
  grid1: {
    height: 350,
    background: '#2C2D33',
    borderTop: '1px solid #afafaf',
    borderBottom: '1px solid #afafaf',
    borderImageSlice: 1,
    borderImageSource:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  grid2: {
    height: 237,
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    borderRadius: '10px',
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 15.98%, rgba(0, 0, 0, 0) 36.28%)',
    border: '1px solid #afafaf',
    borderImageSource:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  Select1: {
    '& label': {
      color: '#e4e4e7',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
      borderColor: '#afafaf',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
    '& .MuiInputBase-input': {
      color: '#ffffff',
    },

    '&:hover .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    color: '#ffffff',
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    background: '#171821',
    borderRadius: '8px',
    // border: '1px solid #afafaf',
    // borderImageSource:
    //   'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },

  TreeSelect1: {
    '.ant-select-single .ant-select-selector': {
      color: '#e4e4e7',
    },
  },
  TableCell1: {
    color: '#CCCCCC',
    borderBottom: '1px solid #CCCCCC',
    background:
      'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
  },

  TableCellHeader1: {
    background: '#2F2E41',
    color: '#ffffff',
    borderBottom: '1px solid #CCCCCC',
  },
}

export default function LookUpStats() {
  const [openMore, setOpenMore] = useState(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [pageNumberTotal, setPageNumberTotal] = useState(500)
  const [statisticsTotalList, setStatisticsTotalList] = useState([])
  const [statisticsTotalListForExcel, setStatisticsTotalListForExcel] = useState([])
  const [OrgData, setOrgData] = useState([])
  const [OrgName, setOrgName] = useState('')
  const [deviceLocation, setDeviceLocation] = React.useState('62d26fb0')

  const [inputOrgid, setInputOrgid] = useState('1110')
  const [locationList, setLocationList] = React.useState([])
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [loadingFlag, setLoadingFlag] = useState(false)
  const [loadingFlagExcel, setLoadingFlagExcel] = useState(false)

  const excelButton = React.useRef()

  //mark
  // useEffect(() => {
  //   console.log("useEffect!!!");
  //   getStatisticsTotal();
  // }, [pageNumber]);
  //

  //초기화면 진입시 최상단 스크롤
  // useEffect(() => {
  //   window.scrollTo(0, 0)
  // }, [])

  const columns = useMemo(
    () => [
      {
        header: '번호',
        Cell: ({ cell, index }) => `${cell.row.index + 1}`,
        size: 30,
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'lon',
        header: '발생위치',
        size: 80,
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'ji_name',
        header: '작업명',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'ji_time',
        header: '작업시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'di_name',
        header: '사고 분석 장비',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'udt',
        header: '발생시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'data_type',
        header: '사고유형',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )

  const table = useMantineReactTable({
    columns: columns,
    data: statisticsTotalList, //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    getRowId: (row, index) => index,
    // onRowSelectionChange: setRowSelection,
    // state: { rowSelection },
    // selectDisplayMode: 'checkbox',
    // enableRowSelection: true,
    // enableMultiRowSelection: true,
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    enableFullScreenToggle: false,
    // paginationDisplayMode: 'pages',
    initialState: { density: 'sm' },

    mantineTableHeadCellProps: {
      sx: { background: '#2F2E41' },
      align: 'center',
      // '.mantine-TableHeadCell-Content-Wrapper': {
      //   color: '#ffffff',
      // },
      ' .mantine-TableHeadCell-Content-Labels .mantine-TableHeadCell-Content-Wrapper': {
        color: '#ffffff',
      },
    },
    mantineTableBodyCellProps: {
      sx: {
        color: '#CCCCCC',
        background:
          'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
      align: 'center',
    },
    mantineDetailPanelProps: {
      sx: {
        color: '#ffffff',
        background:
          'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
      },
    },
    mantineTopToolbarProps: {
      sx: {
        color: '#ffffff',
        background: '#21222D',
        // mantine-Stack-root
        '.mantine-Alert-root': {
          color: '#ffffff',
          background: '#21222D',
        },
        '.mantine-Stack-root': {
          color: '#ffffff',
          background: '#21222D',
        },
      },
    },
    mantineBottomToolbarProps: {
      sx: {
        background: '#21222D',
        '.mantine-Input-input': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '.mantine-InputWrapper-label': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
        '& .mantine-Text-root': {
          color: '#ffffff',
        },
      },
    },
    mantinePaginationProps: {
      sx: {
        background: '#21222D',
        '.mantine-UnstyledButton-root': {
          color: '#ffffff',
          background: '#21222D',
          borderColor: '#CCCCCC',
        },
      },
    },
  })

  useEffect(() => {
    const today = new Date()
    const lastWeek = new Date(today)
    lastWeek.setDate(today.getDate() - 7)

    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    setEndDate(formatDate(today))
    setStartDate(formatDate(lastWeek))
  }, [])

  React.useEffect(() => {
    getLocationList()
    Org()
  }, [])

  React.useEffect(() => {
    setLocationList([])
    getLocationList()
    getOrgName()
  }, [inputOrgid])

  const findFirstLocation = (org) => {
    if (locationList.some((location) => location.orgid === org.orgid)) {
      return org.orgid
    }
    if (org.children && org.children.length > 0) {
      for (let child of org.children) {
        const result = findFirstLocation(child)
        if (result) {
          return result
        }
      }
    }
    return null
  }

  useEffect(() => {
    if (OrgData.length > 0) {
      for (let org of OrgData) {
        const orgWithLocation = findFirstLocation(org)
        if (orgWithLocation) {
          setInputOrgid(orgWithLocation)
          const firstLocation = locationList.find((location) => location.orgid === orgWithLocation)
          if (firstLocation) {
            setDeviceLocation(firstLocation.loid)
          }
          break
        }
      }
    }
  }, [OrgData, locationList])

  useEffect(() => {
    getStatisticsByUserSelect()
  }, [OrgData, inputOrgid, pageNumber])

  const handlePageNumber = (e, v) => {
    console.log('handlePageNumber e:', e)
    console.log('handlePageNumber v:', v)
    setPageNumber(v)
  }

  const handledeviceLocation = (event) => {
    setDeviceLocation(event.target.value)
  }

  const handleOpenMore = () => {
    setOpenMore(!openMore)
  }

  // const getStatisticsTotal = async () => {
  //   try {
  //     const response = await Api.get(
  //       `/api/v1/statistics/?page=${pageNumber}&size=10`
  //     );

  //     if (response.status === 200) {
  //       setPageNumberTotal(response.data.total);
  //       setStatisticsTotalList(response.data.logs);
  //       console.log("getStatisticsTotal ok response.data", response.data);
  //     }
  //   } catch (e) {
  //     console.log("getStatisticsTotal exception", e);
  //   }
  // };

  const getStatisticsByUserSelect = async () => {
    try {
      // setPageNumber(1);

      const response = await Api.get(
        `/api/v1/statistics/get_statistics/by_date?orgid=${inputOrgid}&loid=${deviceLocation}&startDate=${startDate}&endDate=${endDate}&page=${pageNumber}`
      )

      if (response.status === 200) {
        console.log('getStatisticsByUserSelect:', response.data)

        setPageNumberTotal(response.data.total)
        setStatisticsTotalList(response.data.logs)
      }
    } catch (e) {
      console.log('getStatisticsByUserSelect exception', e)
    }
  }

  const getStatisticsByUserSelect2 = async () => {
    try {
      const response = await Api.get(
        `/api/v1/statistics/get_statistics/by_date?orgid=${inputOrgid}&loid=${deviceLocation}&startDate=${startDate}&endDate=${endDate}&page=${pageNumber}`
      )

      if (response.status === 200) {
        console.log('getStatisticsByUserSelect2:', response.data)

        setPageNumberTotal(response.data.total)
        setStatisticsTotalList(response.data.logs)

        // 필요한 경우 데이터를 상태로 설정
        // setStatisticsData(response.data);
      }
    } catch (e) {
      console.log('getStatisticsByUserSelect2 exception', e)
    }
  }

  //엑셀용 전체 데이터 100만건 제한
  const getStatisticsByUserSelect_Total_for_Excel = async () => {
    setLoadingFlagExcel(true)
    try {
      const response = await Api.get(
        `/api/v1/statistics/get_statistics/by_date?orgid=${inputOrgid}&loid=${deviceLocation}&startDate=${startDate}&endDate=${endDate}&page=1&size=1000000`
      )

      if (response.status === 200) {
        console.log('getStatisticsByUserSelect_Total_for_Excel:', response.data)

        ExcelExport(response.data.logs, `안전사고통계조회_${startDate}-${endDate}`, { type: '안전사고통계조회' })
      }
    } catch (e) {
      setLoadingFlagExcel(false)
      console.log('getStatisticsByUserSelect_Total_for_Excel exception', e)
    }
  }

  const Org = async () => {
    try {
      const response = await Api.get('/api/v1/orgn')
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        setOrgData(response.data)
      }
      // console.log('response.data', response.data)
    } catch (e) {
      console.log('Org exception', e)
    }
  }

  const getOrgName = async () => {
    try {
      const response = await Api.get(`/api/v1/orgn/${inputOrgid}`)
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        console.log('getOrgName response.data', response.data)
        if (response.data.orgid === inputOrgid) {
          setOrgName(response.data.orgn)
        }
      }
      // console.log('getOrgName response.data', response.data)
    } catch (e) {
      console.log('getOrgName exception', e)
    }
  }

  const getLocationList = async () => {
    setLoadingFlag(true)
    // const headers = {
    //   istree: true,
    // }
    try {
      // const response = await Api.get(`/api/v1/loca/?orgz_id=${inputOrgid}`, {
      //   headers: headers,
      // })
      const response = await Api.get(`/api/v1/loca/get_loca/without_bf?orgid=${inputOrgid}`)
      if (response.status === 200) {
        console.log('getLocationList:', response.data)
        setLocationList(response.data)
        setLoadingFlag(false)
      }
      // console.log('response.data Users', response.data)
    } catch (e) {
      setLoadingFlag(false)
      console.log('getLocationList exception', e)
    }
  }

  const ExcelExport = (data, fileName, excelObject) => {
    console.log('LookupStats 엑셀테스트 data1:', data)
    if (data) {
      exportToExcel()
    }
    // function convertToString(origin, target) {
    //   if (origin.id === target) return [origin.label]
    //   if (!origin.children) return false
    //   let path
    //   const test = origin.children.find((x) => (path = convertToString(x, target)))
    //   //  console.log("test:",test)
    //   if (path) {
    //     return [origin.label].concat(path)
    //   }
    // }

    // function findPathInMeneResult(param) {
    //   let path
    //   data.map((item) => {
    //     return [item].find((x) => (path = convertToString(x, param)))
    //   })
    //   return path
    // }

    //엑셀 해더이름 변환
    function headerList(p1, p2) {
      console.log('headerList p1:', p1)
      console.log('headerList p2:', p2)

      if (nullCheck(p1) === false) {
        let tempList = Object.keys(p1)
        let copyList = [...tempList]
        console.log('headerList copyList1:', copyList)

        if (p2) {
          switch (p2) {
            case '안전사고통계조회':
              copyList.map((item, index) => {
                if (item === 'lon') {
                  copyList[index] = '발생위치'
                }
                if (item === 'ji_name') {
                  copyList[index] = '작업명'
                }
                if (item === 'ji_time') {
                  copyList[index] = '작업시간'
                }
                if (item === 'di_name') {
                  copyList[index] = '사고 분석 장비'
                }
                if (item === 'udt') {
                  copyList[index] = '발생시간'
                }
                if (item === 'data_type') {
                  copyList[index] = '사고유형'
                }
                if (item === 'user_name') {
                  copyList[index] = '근로자명'
                }
              })
              return [copyList]

            default:
              return [copyList]
          }
        }
      }
    }
    function nullCheck(param) {
      if (param !== undefined && param !== null && param !== '') {
        return false
      } else {
        return true
      }
    }

    function convertObject(param) {
      if (nullCheck(param) === false) {
        const convertObject_temp = JSON.stringify(Object.values(param))
        return convertObject_temp
      }
    }

    async function exportToExcel() {
      if (nullCheck(data) === false && data.length > 0) {
        const now = dayjs().format('YYYY-MM-DD HH:mm:ss')
        const loginId = secureLocalStorage.getItem('loginId')

        //copy array of objects and make changes without modifying originam array

        let copyList = data.map((item) => ({ ...item }))

        copyList.map((item) => {
          if (item.hasOwnProperty('wkl')) {
            item['wkl'] = convertObject(item['wkl'])
          }
          if (item.hasOwnProperty('orglists')) {
            item['orglists'] = convertObject(item['orglists'])
          }
          if (item.hasOwnProperty('deviceLists')) {
            item['deviceLists'] = convertObject(item['deviceLists'])
          }
          if (item.hasOwnProperty('orglist')) {
            item['orglist'] = convertObject(item['orglist'])
          }
          if (item.hasOwnProperty('topic_list')) {
            item['topic_list'] = convertObject(item['topic_list'])
          }
          if (item.hasOwnProperty('b_service_list')) {
            item['b_service_list'] = convertObject(item['b_service_list'])
          }
          if (item.hasOwnProperty('dvloc')) {
            delete item['dvloc']
          }
          if (item.hasOwnProperty('detail')) {
            delete item['detail']
          }
          if (item.hasOwnProperty('pw')) {
            delete item['pw']
          }
          if (item.hasOwnProperty('ladt')) {
            delete item['ladt']
          }
          if (item.hasOwnProperty('lgfcnt')) {
            delete item['lgfcnt']
          }
          if (item.hasOwnProperty('lv')) {
            item['lv'] =
              item['lv'] === 1
                ? 'INFO'
                : item['lv'] === 2
                  ? 'WARN'
                  : item['lv'] === 3
                    ? 'DANGER'
                    : item['lv'] === 4
                      ? 'CRIT'
                      : ''
          }
          if (item.hasOwnProperty('rst')) {
            item['rst'] =
              item['rst'] === 1
                ? '성공'
                : item['rst'] === 2
                  ? '실패'
                  : item['rst'] === 3
                    ? '시작'
                    : item['rst'] === 4
                      ? '성공(종료)'
                      : item['rst'] === 5
                        ? '실패(종료)'
                        : ''
          }

          if (item.hasOwnProperty('fc') && excelObject && excelObject.type === 'userslog') {
            item['fc'] = item['fc'] === 1000 ? '접속정보' : ''
          }
          if (item.hasOwnProperty('idx') && excelObject && excelObject.type === 'userslog') {
            delete item['idx']
          }
          if (item.hasOwnProperty('fdesc') && excelObject && excelObject.type === 'userslog') {
            delete item['fdesc']
          }
          if (item.hasOwnProperty('fc') && excelObject && excelObject.type === 'auditlog') {
            item['fc'] = item['fc'] === 1000 ? '접속정보' : item['fc'] === 2000 ? '파일다운로드' : ''
          }
          if (item.hasOwnProperty('idx') && excelObject && excelObject.type === 'auditlog') {
            delete item['idx']
          }
          if (item.hasOwnProperty('fdesc') && excelObject && excelObject.type === 'auditlog') {
            delete item['fdesc']
          }
          if (item.hasOwnProperty('edt') && excelObject && excelObject.type === 'auditlog') {
            delete item['edt']
          }
          if (item.hasOwnProperty('tm') && excelObject && excelObject.type === 'auditlog') {
            delete item['tm']
          }

          if (item.hasOwnProperty('loid') && excelObject && excelObject.type === '안전사고통계조회') {
            delete item['loid']
          }
          if (item.hasOwnProperty('ji') && excelObject && excelObject.type === '안전사고통계조회') {
            delete item['ji']
          }
          if (item.hasOwnProperty('wid') && excelObject && excelObject.type === '안전사고통계조회') {
            delete item['wid']
          }
          if (item.hasOwnProperty('di') && excelObject && excelObject.type === '안전사고통계조회') {
            delete item['di']
          }
        })
        const typeParam = excelObject !== undefined ? excelObject.type : undefined
        let Heading = headerList(copyList[0], typeParam)
        //Had to create a new workbook and then add the header
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, Heading)
        //Starting in the second row to avoid overriding and skipping headers
        XLSX.utils.sheet_add_json(ws, copyList, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
        XLSX.writeFile(wb, `${fileName}.xlsx`)

        //감사로그
        try {
          const auditObject = {
            cdt: now,
            audit: loginId,
            sys: 'PORTAL',
            fc: '2000',
            tg: fileName,
          }
          const response = await Api.post('/api/v1/audit', auditObject)
          if (response.status === 200) {
            console.log('ExcelExport audit response ok.')
          }
        } catch (e) {
          console.log('ExcelExport catch error:', e)
        }
      }
    }
    setLoadingFlagExcel(false)
  }

  return (
    <div>
      <Grid container>
        <Grid size={12} sx={styles1.grid1}>
          <Typography sx={[styles1.Typography1, { marginTop: 3, marginLeft: 3 }]}>안전사고 통계 정보 조회</Typography>
          {loadingFlag === true ? (
            <div
              style={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
                justifyItems: 'center',
              }}
            >
              <Loader loading={loadingFlag} />
            </div>
          ) : (
            <>
              {' '}
              <Grid container spacing={2} sx={{ marginTop: 3 }}>
                <Grid
                  size={12}
                  sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 2.5 }}
                >
                  <Stack sx={{ padding: 2 }}>
                    <Typography
                      sx={[
                        styles1.Typography1,
                        {
                          marginBottom: 1,
                          fontSize: 18,
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                        },
                      ]}
                    >
                      관리부서
                    </Typography>
                    <Grid
                      fullWitdh
                      container
                      spacing={15}
                      direction="row"
                      sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: 3,
                      }}
                    >
                      <Grid
                        size={12}
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                        }}
                      >
                        {/* mark */}
                        <TreeSelect
                          className="treeSelect"
                          suffixIcon={<ArrowDropDownIcon />}
                          style={{ marginTop: -22 }}
                          value={inputOrgid}
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          treeData={OrgData}
                          treeTitleRender={(item) => {
                            return <Title title={item.orgn} />
                          }}
                          fieldNames={{
                            labal: 'orgid',
                            key: 'orgid',
                            value: 'orgid',
                          }}
                          placeholder="부서 선택"
                          treeDefaultExpandAll
                          onChange={(e) => setInputOrgid(e)}
                        />
                      </Grid>
                    </Grid>
                  </Stack>
                  <Stack sx={{ marginTop: 3 }}>
                    <Typography
                      sx={[
                        styles1.Typography1,
                        {
                          marginBottom: -2,
                          fontSize: 18,
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                        },
                      ]}
                    >
                      대상시설
                    </Typography>
                    <Grid
                      fullWitdh
                      container
                      spacing={15}
                      direction="row"
                      sx={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: 3,
                      }}
                    >
                      <Grid
                        size={12}
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                        }}
                      >
                        <Select
                          value={deviceLocation}
                          onChange={handledeviceLocation}
                          sx={[styles1.Select1, { width: 150 }]}
                        >
                          {locationList.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.loid}>
                                {item.lon}
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </Grid>
                    </Grid>
                  </Stack>
                  <Stack sx={{ marginTop: 4, padding: 2, marginLeft: 5 }}>
                    <Typography
                      sx={[
                        styles1.Typography1,
                        {
                          marginTop: -1.3,
                          fontSize: 18,
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center',
                        },
                      ]}
                    >
                      조회기간 선택
                    </Typography>
                    <Stack direction="row" spacing={3} sx={{ marginTop: 0 }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            sx={[styles1.Select1]}
                            value={dayjs(startDate)}
                            onChange={(newValue) => {
                              const formattedDate = dayjs(newValue).format('YYYY-MM-DD')
                              setStartDate(formattedDate)
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <Typography
                        sx={[
                          styles1.Typography1,
                          {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          },
                        ]}
                      >
                        ~
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            sx={[styles1.Select1]}
                            value={dayjs(endDate)}
                            onChange={(newValue) => {
                              const formattedDate = dayjs(newValue).format('YYYY-MM-DD')
                              setEndDate(formattedDate)
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: 3 }}>
                <Grid
                  size={4}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                ></Grid>
                <Grid
                  size={4}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Stack>
                    <Button sx={{ color: '#D2D2D2', marginTop: 1 }} onClick={() => handleOpenMore()}>
                      {openMore === false ? (
                        <>
                          {' '}
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontSize: '16px',
                              fontWeight: 500,
                              lineHeight: '19.36px',
                              textAlign: 'left',
                              textUnderlinePosition: 'from-font',
                              textDecorationSkipInk: 'none',
                            }}
                          >
                            펼치기
                          </Typography>
                          <ArrowDropDownIcon />
                        </>
                      ) : (
                        <>
                          {' '}
                          <Typography
                            sx={{
                              fontFamily: 'Inter',
                              fontSize: '16px',
                              fontWeight: 500,
                              lineHeight: '19.36px',
                              textAlign: 'left',
                              textUnderlinePosition: 'from-font',
                              textDecorationSkipInk: 'none',
                            }}
                          >
                            숨기기
                          </Typography>
                          <ArrowDropUpIcon />
                        </>
                      )}
                    </Button>
                  </Stack>
                </Grid>
                <Grid
                  size={4}
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      marginLeft: 10,
                      background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
                    }}
                    onClick={() => {
                      setOpenMore(true)
                      handlePageNumber(null, 1)
                      getStatisticsByUserSelect2()
                    }}
                  >
                    통계 자료 생성
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
        {openMore === true ? (
          <>
            <Grid size={12}>
              <Box sx={{ width: '100%', padding: 3 }}>
                <Tabs defaultValue={1}>
                  <TabsList sx={{ width: 150 }}>
                    <Tab value={1}>원천데이터</Tab>
                    {/* <Tab value={2}>통계그래프</Tab> */}
                  </TabsList>

                  <TabPanel value={1}>
                    <div style={{ padding: 3 }}>
                      <Grid container>
                        {/* <Grid size={12}>
                        <Typography
                          sx={[
                            styles1.Typography1,
                            {
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginBottom: 2,
                              marginTop: 2,
                            },
                          ]}
                        >
                          안전사고 플랫폼 원천데이터
                        </Typography>
                      </Grid> */}
                        <Grid
                          size={12}
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            marginBottom: 1,
                          }}
                          // onClick={() => {
                          //   getStatisticsByUserSelect_Total_for_Excel()
                          // }}
                        >
                          <div>
                            <LoadingButton
                              loading={loadingFlagExcel}
                              variant="contained"
                              sx={{
                                color: '#ffffff',
                                background: '#454546',
                                '.MuiLoadingButton-loadingIndicator': {
                                  color: '#ffffff',
                                },
                              }}
                              onClick={() => getStatisticsByUserSelect_Total_for_Excel()}
                            >
                              <img style={{ width: 25, height: 25 }} src={excel_img}></img>
                              &nbsp;엑셀 내보내기
                            </LoadingButton>
                          </div>
                        </Grid>
                      </Grid>
                      <Paper>
                        <MantineReactTable table={table} />
                      </Paper>
                      <Box
                        sx={{
                          justifyItems: 'center',
                          alignItems: 'center',
                          marginTop: 2,
                        }}
                      >
                        <Stack spacing={2}>
                          <MyPagination
                            count={pageNumberTotal}
                            variant="outlined"
                            shape="rounded"
                            page={pageNumber}
                            onChange={(event, page) => handlePageNumber(event, page)}
                          />
                        </Stack>
                      </Box>
                    </div>
                  </TabPanel>
                </Tabs>
              </Box>
            </Grid>
          </>
        ) : (
          ''
        )}
      </Grid>
    </div>
  )
}
